/*
 *@filename: token-interceptor.service.ts
 *@purpose: service interceptor for req & resp
 *@author: teamVeho
 */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { VproService } from "../service/vpro/vpro.service";
@Injectable({
  providedIn: "root",
})
export class TokenInterceptorService implements HttpInterceptor {
  errorMsg = false;
  errorMessage = "";
  constructor(private injector: Injector, private router: Router) { }
  /* defining interceptor function for modifying the req */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authService = this.injector.get(VproService);
    let tokenizedReq = req;
    if (
      !(req && req.method === "PUT" && req.url.includes("s3.amazonaws.com"))
    ) {
      /* Included condition to remove Headers for null Tokens */
      if (authService.getToken()) {
        tokenizedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${authService.getToken()}`,
          },
        });
      }

    }
    return next.handle(tokenizedReq).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
          }
        },
        (error) => {
          if (error) {
            if (error.message === 400) {
              this.errorMsg = true;
              this.errorMessage = "server Bad Request.";
            } else if (error.message === 401) {
              this.errorMsg = true;
              this.errorMessage = "Unauthorized Access.";
              this.router.navigate(["/login"]);
            } else if (error.message === 422) {
              this.errorMsg = true;
              this.errorMessage = "Unprocessable Request.";
            } else if (error.message === 408) {
              this.errorMsg = true;
              this.errorMessage = "Request Timeout.";
            } else if (error.message === 500) {
              this.errorMsg = true;
              this.errorMessage = "Internal Server Error.";
            }
          }
        }
      )
    );
  }
}
